const isPrefillLoading = ({ userDataLoading , isUserDataPrefilledBoolean , isAddressBookEnabled , addressBookPrefillValidationResult , isLoggedIn , isMyAccountEnabled , optInsDataLoading  })=>{
    const isUserDataPrefillDone = !userDataLoading && typeof isUserDataPrefilledBoolean !== 'undefined';
    const isAddressBookPrefillDone = !isAddressBookEnabled || addressBookPrefillValidationResult;
    const isAllPrefillDone = !isLoggedIn || isUserDataPrefillDone && isAddressBookPrefillDone;
    return isMyAccountEnabled && !isAllPrefillDone || optInsDataLoading;
};

export { isPrefillLoading };
//# sourceMappingURL=is-prefill-loading.js.map
